import { useState } from "react";

const faqs = [
  {
    q: "皮皮喵漫画多久更新一次推荐？",
    a: "我们每周更新三期治愈向作品推荐，并结合连载动态持续补充追更信息，确保软萌画风与温馨剧情的清单常看常新。",
  },
  {
    q: "怎么快速找到合口味的软萌画风作品？",
    a: "在「萌系推荐」板块使用分类标签即可筛选，比如软萌画风、治愈温情、可爱角色、温馨剧情等。你也能在治愈系漫画清单里直接看到编辑部精选的佳作。",
  },
  {
    q: "治愈系漫画清单是如何挑选作品的？",
    a: "每一部入选作品都由编辑部亲读把关，综合画风完成度、剧情温度与可爱角色塑造来判断，只推荐真正能带来治愈体验的作品。",
  },
  {
    q: "我喜欢的作品也可以投稿推荐吗？",
    a: "当然可以。欢迎通过页面底部的联系方式向我们推荐你心中的宝藏治愈作品，编辑部会认真阅读并评估是否收录进后续清单。",
  },
  {
    q: "这些治愈系漫画在哪里可以看到？",
    a: "我们提供的是作品推荐与清单，方便你按萌系画风和温馨剧情快速定位。你可以通过作品名称在官方平台搜索阅读，享受完整观看体验。",
  },
  {
    q: "追更提醒功能如何使用？",
    a: "我们会为每部连载中的作品标注最新话数，并在每周更新中汇总动态。关注我们的更新栏目，就能第一时间知道心仪作品的进度。",
  },
];

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number>(0);

  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };

  return (
    <section id="faq" className="bg-background-100/70 py-16 md:py-20">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="text-center">
          <span className="text-sm font-bold uppercase tracking-widest text-accent-600">
            常见问题
          </span>
          <h2 className="mt-2 font-heading text-3xl text-foreground-950 md:text-4xl">
            关于皮皮喵漫画，你想知道的
          </h2>
        </div>

        <div className="mt-8 flex flex-col gap-3">
          {faqs.map((faq, index) => {
            const open = openIndex === index;
            return (
              <div
                key={faq.q}
                className="overflow-hidden rounded-xl bg-background-50 ring-1 ring-background-200"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? -1 : index)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <h3 className="font-bold text-foreground-950">{faq.q}</h3>
                  <span
                    className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-secondary-100 text-secondary-900 transition-transform ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                <div
                  className={`grid transition-all duration-300 ${
                    open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                  }`}
                >
                  <div className="overflow-hidden">
                    <p className="px-5 pb-5 text-sm leading-relaxed text-foreground-600">
                      {faq.a}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}